import { StyleSheet } from 'react-native';

import { Text, tokens } from '@fhs/ui';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';

const DEFAULT_WELCOME_MESSAGE = 'Welcome to Firehouse Subs!';

export function WelcomeMessage() {
  const { isAuthenticated, user, loading } = useAuthContext();

  // Show fallback during loading or when signed out
  if (loading || !isAuthenticated) {
    return (
      <Text weight="semibold" style={styles.welcomeMessage}>
        {DEFAULT_WELCOME_MESSAGE}
      </Text>
    );
  }

  // Signed-in experience: extract first name from user profile
  const fullName = user?.details?.name ?? '';
  const firstName = fullName.split(' ')[0]?.trim();

  // If first name is missing/empty, show fallback
  if (!firstName) {
    return (
      <Text weight="semibold" style={styles.welcomeMessage}>
        {DEFAULT_WELCOME_MESSAGE}
      </Text>
    );
  }

  return (
    <Text weight="semibold" style={styles.welcomeMessage}>
      Welcome back, <Text style={styles.firstName} weight="semibold">{firstName}</Text>!
    </Text>
  );
}

const styles = StyleSheet.create({
  welcomeMessage: {
    fontSize: 18,
    lineHeight: 25,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  firstName: {
    color: tokens.colors.$houseRed,
  },
});
